import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IUnitDefault } from "../../Types"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipAnchorsViewProps } from "./Params"

// Anchors & windlasses. Detail-level section, only rendered when at least one is present.
export function PrintShipAnchorsView({ data }: PrintShipAnchorsViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = !!(includeShipDataType === ShipDataType.details && shipData?.anchors && shipData.anchors.length > 0);

  return (
    <PrintListBlock title={t("anchors")} visible={visible}>
      {shipData?.anchors && shipData.anchors.length > 0 && shipData.anchors.map((anchor, index) => (
        <div key={anchor.id || index}>
          <BlockRow>
            <BlockField label={t("anchor_type")} className="block-field-150">{anchor.anchorType ? (predefined.anchorType.includes(anchor.anchorType) ? t(`anchor_${anchor.anchorType}`) : anchor.anchorType) : anchor.anchorType}</BlockField>
            <BlockField label={t("anchor_weight")} className="block-field-120">{anchor.weight} {anchor.weightUnit || (anchor.weight ? IUnitDefault.weight : "")}</BlockField>
            <BlockField label={t("anchor_location")} className="block-field-150">{anchor.placeInstallation ? t(anchor.placeInstallation) : anchor.placeInstallation}</BlockField>
            <BlockField label={t("anchor_chain")} className="block-field-210">{anchor.chain}</BlockField>
            <BlockField label={t("anchor_chain_lead")} className="block-field-150">{anchor.chainLead}</BlockField>
          </BlockRow>

          <BlockRow className="block-row-last">
            <BlockField label={t("anchor_windlass")} className="block-field-150">{anchor.windlass}</BlockField>
            <BlockField label={t("anchor_windless_drive")} className="block-field-120">{anchor.windlassDrive}</BlockField>
            <BlockField label={t("anchor_windless_manfacturer")}>{anchor.windlassManufacturer}</BlockField>
          </BlockRow>
        </div>
      ))}
    </PrintListBlock>
  );
}
